<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i class="fas fa-file"></i> Historia antigua
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button right style="right" variant="primary" @click="backContacts">{{
          $t("generic.btnBack")
        }}
        </b-button>
      </template>
      <b-container>
        <b-col>
          <b-row class="mt-3">
            <div v-for="(i, index) in historicOld" :key="index">
              <h4 class="title-typography-color">
                <i aria-hidden="true" class="fas fa-file-alt mr-2"></i>Paciente
              </h4>
              <hr class="title-typography-color dot-typography" />

              <div>
                <h6>NOMBRE: {{ i.patient.name }} {{ i.patient.lastname }}</h6>
                <h6>NIF: {{ i.patient.document }}</h6>
                <h6>EMAIL: {{ i.patient.email }}</h6>
                <h6>TELÉFONO: {{ i.patient.phone }}</h6>
              </div>
              <h4 class="title-typography-color">
                <i aria-hidden="true" class="fas fa-file-alt mr-2"></i>Información antigua
              </h4>
              <hr class="title-typography-color dot-typography" />
              <div>
                <h6>
                  <b-avatar class="mr-2" v-bind:src="
                    i.professional.avatarUrl
                      ? i.professional.avatarUrl +
                      '/' +
                      getAuthentication()
                      : ''
                  "></b-avatar>
                  {{ i.professional.name }} {{ i.professional.lastname }}
                </h6>
              </div>
              <p v-html="formatData(i.data)"></p>
            </div>
          </b-row>
        </b-col>
      </b-container>
    </iq-card>
  </b-container>
</template>
<script>
import { xray } from "../../../config/pluginInit";

import historicOldService from "../../../services/historicOld";

import utilsService from "../../../services/utils";



export default {
  name: "HistoricOld",
  components: {},
  mounted() {
    xray.index();
    this.findByPatientId();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_HISTORIC_CLINIC_OLD", info: "" });
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    backContacts() {
      this.$router.push({
        name: "auth.professional.contact.historicclinic",
      });
    },
    formatData(data) {
      if (data) {
        data = data.replace("[", "");
        data = data.replace("---", "");
        data = data.replace('note: "', "");
        data = data.replace("]", "");
        data = data.slice(0, -1);
        data = data.slice(0, -1);
        data = data.replace(/\n/g, "<br>");
        data = data.split("\\n").join(" ");
        data = data.split('\\"').join('"');
        data = data
          .split("date_when:")
          .join("<span class='font-weight-bold'>Fecha:</span>");
        data = data
          .split("note: |-")
          .join("<span class='font-weight-bold'>Nota:</span>");
        data = data.split(", ---").join("----------------------------------");
      }
      return data;
    },
    findByPatientId() {
      let self = this;

      this.$awn.asyncBlock(
        historicOldService.findByPatientId(this.$route.query.patientId),
        (response) => {
          if (response && response.data && response.data.length > 0) {
            response.data.forEach(function (item) {
              self.historicOld.push(item);
              console.log(item);
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "historicOldService.findByPatientId",
            module: "view-pages-professional-hcold",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              patientId: this.$route.query.patientId
            })
          });
        },
        " "
      );
    },
  },

  data() {
    return {
      historicOld: [],
    };
  },
};
</script>
